// import { red } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

// A custom theme for this app

const primaryColor = '#232360';

const primaryMain = "#0A43AE";
const primaryDark = "#001755";
const primaryLight = "#02297F";
const primaryMoreLight = "#0C1D48";
const primaryDark2 = "#050F2D";
const primary6 = '#082672';

const secondarymain = "#CBD2E2";

const successMain = "#2DD36F";
const successDark = "#1F944E";
const successLight = "#E7FFF0";

const warningMain = "#FFC409";
const warningDark = "#B38906";
const warningLight = "#FFF3CE";


const errorMain = "#EB445A";
const errorDark = "#A5303F";
const errorLight = "#FBDADE";


const grey200 = '#1B2338';
const grey100 = '#2E3852';
const border2 = '#162C63';
const white = '#fff';
const grey2 = '#0D2D7D';




const defaultTheme = createTheme();
let theme = createTheme({
    typography: {
        //  fontFamily: 'GT Walsheim Pro, sans-serif',
        // fontFamily: 'CabinetGrotesk-Variable',
        fontFamily: '"Jost", sans-serif',

        // fontSize: 12,
    },

    breakpoints: {
        values: {
            xs: 0,    // Extra small devices (phones)
            sm: 600,  // Small devices (tablets)
            md: 992,  // Medium devices (desktops)
            lg: 1200, // Large devices (larger desktops)
            xl: 1400, // Extra large devices
            xxl: 1600, // Extra large devices
        },
    },

    palette: {
        // mode: 'dark',
        background: {
            default: "#F5F5F5",
        },
        primary: {
            main: primaryMain,
            light: primaryLight,
            dark: primaryDark,

            morelight: primaryMoreLight,
            dark2: primaryDark2,
            contrastText: '#fff',


            primary2: '#001E70',
            primary3: ' rgba(0, 66, 191, 0.4) ',
            primary1: '#010A2B',
            primary4: '#041855',
            primary5: '#052168',
            primary6: '#082672',



        },
        secondary: {
            main: "#CBD2E2",
            dark: "#232360",
            light: "#B5B5B9",
            contrastText: '#fff'
        },
        border: {
            border1: "#09163C",
            border2: '#162C63',
        },
        disablegrey: {
            gray1: '#808491',
            grey2: '#0D2D7D',
        },
        white: {
            white: '#fff'
        },
        greyshades: {
            grey200: '#1B2338',
            grey100: '#2E3852',
        },
        success: {
            main: successMain,
            dark: successDark,
            light: successLight,
        },
        warning: {
            main: warningMain,
            dark: warningDark,
            light: warningLight,
        },
        error: {
            main: errorMain,
            dark: errorDark,
            light: errorLight,
        },
    },
    shape: {
        borderRadius: 4,
    },


});
theme = createTheme(theme, {
    components: {
        MuiButtonBase: {
            defaultProps: {
                disableRipple: true,
            },
        },


        MuiMenu: {
            styleOverrides: {
                paper: {
                    backgroundColor: '#f0f0f0', // Example background color
                    borderRadius: '8px', // Custom border radius
                    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)', // Custom shadow
                },
                list: {
                    padding: '8px 0', // Custom padding for the list
                    color: '#333', // Text color
                    // zIndex:'99999999999',
                    '& .MuiMenuItem-root': {
                        fontSize: '16px', // Item font size
                        '&:hover': {
                            backgroundColor: '#e0e0e0', // Hover color
                        },
                    },
                },
            }
        },
        MuiRadio: {
            styleOverrides: {
                root: {
                    color: '#999999', // Default color for unselected radio buttons
                    '&.Mui-checked': {
                        color: 'primaryMain', // Color for selected radio button
                    },
                    '&:hover': {
                        backgroundColor: 'transparent', // Background on hover
                    },
                    '& .MuiSvgIcon-root': {
                        fontSize: '1.5rem', // Adjusts the size of the radio button
                    },
                },
            },
        },

        MuiButton: {
            styleOverrides: {
                root: {
                    boxShadow: 'none',
                    textTransform: 'capitalize',
                    '&:hover': {
                        boxShadow: 'none',
                        background:primaryMain
                    },
                },
                sizeMedium: {
                    paddingLeft: '20px',
                    paddingRight: '20px',
                    height: '45px',
                    fontWeight: 500,
                    borderRadius: 5,
                    fontSize: '1rem',
                    textTransform: 'capitalize',
                    whiteSpace: 'nowrap',
                },
            },
            variants: [
                {
                    props: { variant: 'selectSmall', color: 'primary' },
                    style: {
                        padding: '4px 6px',
                        minWidth: 'max-content',
                        color: primaryMain,
                        fontSize: '0.9rem',
                        height: 30,

                        '&:hover': {
                            backgroundColor: primaryLight,
                        }
                    },
                },
                {
                    props: { variant: 'selectSmall', color: 'secondary' },
                    style: {
                        paddingLeft: 0,
                        paddingRight: 0,
                    },
                },
            ],
        },

        MuiChip: {
            variants: [
                {
                    props: { variant: 'new', color: 'default' },
                    style: {
                        borderRadius: 5,
                        backgroundColor: successLight,
                        color: successMain,
                        border: '1px solid',
                        borderColor: successMain,
                        fontWeight: 500,
                        height: "25px",
                        lineHeight: '25px',
                        minWidth: "120px"
                    }
                },
                {
                    props: { variant: 'approved', color: 'default' },
                    style: {
                        borderRadius: 5,
                        backgroundColor: successLight,
                        color: successMain,
                        border: '1px solid',
                        borderColor: successMain,
                        fontWeight: 500,
                        height: "25px",
                        lineHeight: '25px',
                        minWidth: "120px"
                    }
                },
                {
                    props: { variant: 'submited', color: 'default' },
                    style: {
                        borderRadius: 5,
                        backgroundColor: warningLight,
                        color: warningMain,
                        border: '1px solid',
                        borderColor: warningMain,
                        fontWeight: 500,
                        height: "25px",
                        lineHeight: '25px',
                        minWidth: "120px"
                    }
                },
                {
                    props: { variant: 'hold', color: 'default' },
                    style: {
                        borderRadius: 5,
                        backgroundColor: errorLight,
                        color: errorMain,
                        border: '1px solid',
                        borderColor: errorMain,
                        fontWeight: 500,
                        height: "25px",
                        lineHeight: '25px',
                        minWidth: "120px"
                    }
                },
                {
                    props: { variant: 'progress', color: 'default' },
                    style: {
                        borderRadius: 5,
                        backgroundColor: primaryLight,
                        color: primaryMain,
                        border: '1px solid',
                        borderColor: primaryMain,
                        fontWeight: 500,
                        height: "25px",
                        lineHeight: '25px',
                        minWidth: "120px"

                    }
                },
                {
                    props: { variant: 'review', color: 'default' },
                    style: {
                        borderRadius: 5,
                        backgroundColor: warningLight,
                        color: warningMain,
                        border: '1px solid',
                        borderColor: warningMain,
                        fontWeight: 500,
                        height: "25px",
                        lineHeight: '25px',
                        minWidth: "120px"

                    }
                },
                {
                    props: { variant: 'todo', color: 'default' },
                    style: {
                        borderRadius: 5,
                        backgroundColor: '#DDDDDD',
                        color: '#757575',
                        border: '1px solid',
                        borderColor: '#757575',
                        fontWeight: 500,
                        height: "25px",
                        lineHeight: '25px',
                        minWidth: "120px"

                    }
                }
            ]
        },
        MuiAppBar: {
            styleOverrides: {
                colorPrimary: {
                    backgroundColor: "#fff",
                    color: "#000",
                }
            }
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    minHeight: '0.75em',
                    lineHeight: '0.75em',
                    borderColor: '#EEEEEE'
                },
                input: {
                    height: '0.75em',
                    '&::placeholder': {
                        opacity: 1,
                        color: "#424242",
                    }
                }
            }
        },

        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    Color: '#fff',
                    background: '#041855',
                    borderRadius: '12px',
                    borderColor: '#0A43AE',
                    fontSize: '16px',
                    fontWeight: '400',
                    padding: ' 16px 10px',

                    height: '40px',
                    '& .MuiOutlinedInput-notchedOutline': {
                        Color: '#fff',
                        borderColor: '#0A43AE',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        Color: '#fff',
                        borderColor: '#0A43AE',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        Color: '#fff',
                    },
                    '&.css-4ztryh-MuiInputBase-root-MuiOutlinedInput-root': {
                        Color: '#fff'
                    },
                    input: {
                        '&:-webkit-autofill': {
                            WebkitBoxShadow: '0 0 0 100px #1B2338 inset', // Force white background
                            WebkitTextFillColor: '#fff', // Force text color (black in this case)
                            borderRadius: '0px'
                        },
                        padding: '6px',
                        '&::placeholder': {
                            color: '#CBD2E2', // Change the color of the placeholder
                        },

                    },
                },
            }
        },
        MuiInputLabel: {
            styleOverrides: {

                root: {
                    lineHeight: '0.75em',
                    overflow: 'inherit'
                }
            }
        },
        MuiSelect: {
            styleOverrides: {
                select: {
                    minHeight: '0.75em',
                }
            }
        },
        MuiTableHead: {
            styleOverrides: {
                root: {
                    '& .MuiTableCell-root': {
                        color: primaryColor,
                        fontWeight: 600,
                    }
                },
            }
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    textTransform: 'capitalize',
                    fontWeight: 500,
                    fontSize: 16,
                },
            }
        },
        MuiContainer: {
            styleOverrides: {
                root: {
                    padding: '20px',
                    maxWidth: '100%',

                    '@media (min-width:600px)': {
                        maxWidth: '100%',
                        padding: '32px',
                    },
                    '@media (min-width:960px)': {
                        maxWidth: '100%',
                        padding: '32px 80px',
                    },
                    '@media (min-width:1280px)': {
                        maxWidth: '100%',
                        padding: '32px 80px',
                    },
                },
            },
        },
        MuiTabs: {
            styleOverrides: {
                root: {
                    "& .MuiButtonBase-root ": {
                        color: '#757575',
                    }
                },
            }
        },
        MuiTypography: {
            styleOverrides: {
                root: {
                    '& .MuiTypography-noWrap': {
                        whiteSpace: "normal"
                    }
                }
            }
        },
        MuiFormControlLabel: {
            styleOverrides: {
                root: {
                    '& .MuiFormControlLabel-label':
                    {
                        whiteSpace: "nowrap"
                    }
                },
            }
        },
        MuiBreadcrumbs: {
            styleOverrides: {
                root: {
                    padding: "0 4px",
                    '& .MuiBreadcrumbs-li': {
                        fontSize: 14
                    },
                    '& .MuiTypography-body1': {
                        fontSize: 14
                    }
                },
            }
        },
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    '& .MuiFormLabel-asterisk': {
                        fontSize: 19
                    },
                },
            }
        },
        MuiAvatar: {
            styleOverrides: {
                root: {
                    fontSize: "16px",
                    textTransform: "uppercase"
                }
            }
        },
        MuiTable: {
            styleOverrides: {
                background: 'red',
                root: {
                    "& .MuiTableHead-root": {
                        whiteSpace: "nowrap",
                        background: 'red',
                    }
                }
            }
        },
        MuiTableSortLabel: {
            styleOverrides: {
                root: {
                    whiteSpace: "nowrap"
                }
            }
        },
        MuiListItem: {
            styleOverrides: {
                root: {
                    "& :hover": {
                        backgroundColor: primaryLight,
                    }
                }
            }
        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    backgroundColor: primary6,
                    padding: '14px',
                    borderRadius: '12px',
                    width: '600px',
                    maxWidth: '100%',
                    border: '1px solid',
                    borderColor: grey2,


                    [theme.breakpoints.up('sm')]: {
                        padding: '20px 24px',
                    },


                },
                root: {
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    "& .MuiDialog-paper": {
                        verticalAlign: "top"
                    }
                }
            }
        },
        MuiTable: {
            styleOverrides: {
                root: {
                    backgroundColor: 'transparent', // Custom background for the entire table
                    borderCollapse: 'separate',  // Modify table behavior (border collapse, spacing)
                    borderSpacing: '0 0px',     // Add spacing between rows
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    padding: ' 24px 12px 12px 12px',
                    borderBottom: '1px solid ',
                    borderBottomColor: primaryMain,
                },
                head: {
                    backgroundColor: primaryLight,
                    color: '#CBD2E2',
                    fontWeight: 'bold',
                    fontSize: '14px',
                    fontWeight: '500',
                    '&:first-child': {
                        padding: '12px  12px 12px 16px',

                        '@media (min-width:600px)': {
                            padding: '12px  12px 12px 40px',
                        },
                    },
                    '&:last-child': {
                        padding: '12px  16px 12px 12px',

                        '@media (min-width:600px)': {
                            padding: '12px  24px 12px 12px',
                        },
                    }
                },
                body: {
                    fontSize: '16px',
                    fontWeight: '400',
                    color: white,
                    '&:first-child': {
                        padding: '12px  12px 12px 16px',

                        '@media (min-width:600px)': {
                            padding: '12px  12px 12px 40px',
                        },
                    },
                    '&:last-child': {
                        padding: '12px  16px 12px 12px',

                        '@media (min-width:600px)': {
                            padding: '12px  24px 12px 12px',
                        },
                    }
                },
            },
        },
        MuiTableRow: {
            styleOverrides: {
                root: {
                    '&:nth-of-type(even)': {
                        backgroundColor: 'transparent',
                    },
                    '&:hover': {
                        backgroundColor: 'transparent',
                    },
                },
                head: {
                    height: 'auto',
                    color: '#CBD2E2',
                },
            },
        },
        MuiTableHead: {
            styleOverrides: {
                background: primaryDark2,

                root: {
                    background: primaryDark2,
                    color: '#CBD2E2', // Border below the table header

                },
            },
        },
        MuiTableContainer: {
            styleOverrides: {
                root: {

                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundColor: 'transparent', // Remove background globally
                    boxShadow: 'none',              // Remove shadow globally if needed
                },
            },
        },
        MuiTabs: {
            styleOverrides: {
                root: {
                    minHeight: '48px',
                    borderBottom: '1px solid',
                    borderBottomColor: border2,
                    padding: '0 16px',
                    '@media (min-width:600px)': {
                        padding: '0 32px',
                    },
                },
                indicator: {
                    backgroundColor: primaryMain,
                    height: '3px',
                },
            },
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    fontWeight: 400,
                    fontSize: '16px',
                    padding: '12px 16px',
                    minHeight: '48px',
                    color: secondarymain,
                    '&.Mui-selected': {
                        color: white,
                        fontWeight: 700,
                    },
                },
            },
        },
        MuiTabScrollButton: {
            styleOverrides: {
                root: {
                    color: primaryMain,               // Customize color of scroll buttons (for scrollable tabs)
                },
            },
        },
    },
})
export default theme;